import { render, staticRenderFns } from "./revocation.vue?vue&type=template&id=4c2b017c&scoped=true"
import script from "./revocation.vue?vue&type=script&lang=js"
export * from "./revocation.vue?vue&type=script&lang=js"
import style0 from "./revocation.vue?vue&type=style&index=0&id=4c2b017c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2b017c",
  null
  
)

export default component.exports